/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Home_Link_Categories_HintInputs */

const vi_shop_home_link_categories_hint = /** @type {(inputs: Shop_Home_Link_Categories_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chọn tối đa ${i?.max} danh mục và / hoặc loại sản phẩm bên dưới (ít nhất một); web mở danh sách sản phẩm lọc theo đó.`)
};

/**

* @param {Shop_Home_Link_Categories_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_categories_hint = /** @type {((inputs: Shop_Home_Link_Categories_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Categories_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_categories_hint(inputs)
});